import { TooltipPosition } from '@angular/material/tooltip';
import { LoadKey, loadKey } from 'src/app/infrastructure/services/loading-services/models/loadKey';
import { ButtonColor } from './button-color';
import { ISectionButtonData, sectionButtonData } from '../../central-page/components/button-blocks/models/_base-section-button';
import { ButtonType } from './button-type';

export const buttonData = {
    ...sectionButtonData,
    autofocus: 'autofocus',
    class: 'class',
    click: 'click',
    color: 'color',
    formName: 'formName',
    hover: 'hover',
    loadKey: 'loadKey',
    style: 'style',
    tabIndex: 'tabIndex',
    text: 'text',
    type: 'type',
} as const;

export type TButtonData = (typeof buttonData)[keyof typeof buttonData];

export interface IButtonData extends ISectionButtonData {
    [buttonData.autofocus]?: boolean | null;
    [buttonData.class]?: string | string[] | null;
    [buttonData.click]?: string | null;
    [buttonData.color]?: ButtonColor | null;
    [buttonData.disabled]?: boolean | null;
    [buttonData.formName]?: string | null;
    [buttonData.hide]?: boolean | null;
    [buttonData.hover]?: boolean | null;
    [buttonData.loadKey]?: LoadKey | LoadKey[] | null;
    [buttonData.lockOnLoad]?: boolean | null;
    [buttonData.style]?: string | Record<string, string> | null;
    [buttonData.tabIndex]?: string | null;
    [buttonData.text]?: string | null;
    [buttonData.tooltipPosition]?: TooltipPosition | null;
    [buttonData.tooltip]?: string | null;
    [buttonData.type]?: ButtonType | null;
}

export abstract class _BaseButtonData 
    implements IButtonData
{
    [buttonData.autofocus]: boolean = false;
    [buttonData.class]: string | string[] | null = null;
    [buttonData.click]: string | null = null;
    [buttonData.color]: ButtonColor | null = null;
    [buttonData.disabled]: boolean | null = false;
    [buttonData.formName]: string | null = null;
    [buttonData.hide]: boolean | null = true;
    [buttonData.hover]: boolean | null = true;
    [buttonData.loadKey]: LoadKey | LoadKey[] = loadKey.default;
    [buttonData.lockOnLoad]: boolean | null = false;
    [buttonData.style]: string | Record<string, string> | null = null;
    [buttonData.tabIndex]: string = '0';
    [buttonData.text]: string | null = null;
    [buttonData.tooltipPosition]: TooltipPosition | null = 'above';
    [buttonData.tooltip]: string | null = null;
    [buttonData.type]: ButtonType = 'button';
}
